import React from 'react';
import PropTypes from 'prop-types';
import { DropTarget as reactDropTarget } from 'react-dnd';

import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';
import DraggableToolPaletteItem from './DraggableToolPaletteItem';
import CustomDragLayer from '../common/DynamicDnD/CustomDragLayer';

const dropTarget = {
  canDrop: () => true,

  drop(props, monitor) {
    props.handleTargetDrop(monitor.getItem(), props.gridType);
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

const DraggableToolPaletteGrid = props => {
  const {
    isStudyUniverse,
    gridEntry,
    index,
    gridType,
    getSelectedTargets,
    handleBaseSelectionChange,
    selectedOptions,
    selectGridItem,
    selectedPreviewItems,
    renderToggleButton,
    updateGridData,
    crosstabStudy,
    updateCrosstabTitleHeader,
    tooltipVal,
    toggleLabelFlag,
    crosstabViewFlag,
  } = props;
  if (isStudyUniverse) {
    return props.connectDropTarget(
      <span className="">STUDY UNIVERSE</span>,
    );
  }
  return props.connectDropTarget(
    <div key={gridEntry.id} className="line-height">
      <CustomDragLayer selectedPreviewItems={selectedPreviewItems()} />
      <div
        className={`hover-bg${
          crosstabViewFlag ? '' : selectedOptions[gridEntry.id] >= 0 ? ' selected' : ''
        }`}
      >
        <div className={`display-just-inline ${gridType === 'BasesDataGrid' ? 'base-grid-items' : ''}`}>
          {/* {gridEntry.dataSmartSearch ? (<span
              className="crosstab-recent-item-edit edit"
              onClick={() => handleCrosstabEdit(
                'column', gridEntry.id, gridEntry.dataSmartSearch, gridEntry.keyword)}
            />) : (<span
              className="crosstab-recent-item-edit edit"
            />)} */}

          {renderToggleButton !== undefined
            ? renderToggleButton(gridEntry.id, gridType)
            : () => { }}
          <DraggableToolPaletteItem
            gridEntry={gridEntry}
            selectGridItem={selectGridItem}
            index={index}
            gridType={gridType}
            handleBaseSelectionChange={
              handleBaseSelectionChange !== undefined
                ? handleBaseSelectionChange
                : () => {}
            }
            getSelectedTargets={() => getSelectedTargets(gridType)}
            selectedOptions={selectedOptions}
            updateGridData={updateGridData}
            crosstabStudy={crosstabStudy}
            updateCrosstabTitleHeader={updateCrosstabTitleHeader}
            tooltipVal={tooltipVal}
            toggleLabelFlag={toggleLabelFlag}
            crosstabViewFlag={crosstabViewFlag}
          />
        </div>
      </div>
    </div>,
  );
};

DraggableToolPaletteGrid.propTypes = {
  isStudyUniverse: PropTypes.bool,
  gridEntry: PropTypes.shape({}),
  index: PropTypes.number,
  gridType: PropTypes.string,
  getSelectedTargets: PropTypes.func,
  handleBaseSelectionChange: PropTypes.func,
  selectedOptions: PropTypes.shape({}),
  selectGridItem: PropTypes.func,
  selectedPreviewItems: PropTypes.func,
  connectDropTarget: PropTypes.func,
  renderToggleButton: PropTypes.func,
  updateGridData: PropTypes.func,
  crosstabStudy: PropTypes.string,
  tooltipVal: PropTypes.string,
  crosstabViewFlag: PropTypes.bool,
};

export default reactDropTarget([DnDItemTypes.DnD_ITEM_TYPE_5], dropTarget, collect)(
  DraggableToolPaletteGrid,
);
